"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
const react_1 = require("react");
const config_1 = require("config");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const utils_1 = require("utils");
const useSalesTable = ({ locationId }) => {
    // Dates
    const todaysDate = new Date();
    const startDate = (0, date_fns_1.subDays)(todaysDate, config_1.REPORTS_START_OFFSET_DAYS);
    const endDate = new Date();
    endDate.setDate(todaysDate.getDate() + 1);
    // State
    const [displayedNextDayTransactions, setDisplayedNextDayTransactions] = (0, react_1.useState)([]);
    const [displayedPendingTransactions, setDisplayedPendingTransactions] = (0, react_1.useState)([]);
    // API Hooks
    const [postSalesReportsNextDay, { data: nextDayReport, isError: nextDayError, isLoading: nextDayLoading },] = (0, merchant_management_v1_api_1.usePostMerchantManagementV1ReportsFilteredSalesMutation)();
    const [postSalesReportsScheduledPending, { data: scheduledPendingReport, isError: scheduledPendingError, isLoading: scheduledPendingLoading, },] = (0, merchant_management_v1_api_1.usePostMerchantManagementV1ReportsFilteredSalesMutation)();
    const salesReportError = nextDayError || scheduledPendingError;
    const salesReportLoading = nextDayLoading || scheduledPendingLoading;
    const handleFilters = (filterCriteria, data) => {
        const { filterOption, searchField } = filterCriteria;
        if (!searchField) {
            return data;
        }
        const filteredData = data.filter((transaction) => {
            if (filterOption === config_1.TRANSACTION_FILTERS.CUSTOMER_NAME) {
                const fullName = (0, utils_1.getFullName)(transaction?.name).toLowerCase();
                return fullName.includes(searchField.toLowerCase());
            }
            else if (filterOption === config_1.TRANSACTION_FILTERS.ACCOUNT_NUMBER) {
                return transaction.alphaeonAccountNumber.includes(searchField);
            }
        });
        return filteredData;
    };
    const handlePendingTransactionFilter = (values) => {
        const data = handleFilters(values, scheduledPendingReport?.[0]?.transactions ?? []);
        data && setDisplayedPendingTransactions(data);
    };
    const handleNextDayFilter = (values) => {
        const data = handleFilters(values, nextDayReport?.[0]?.transactions ?? []);
        data && setDisplayedNextDayTransactions(data);
    };
    const fetchSalesReport = (values = {
        startDate: undefined,
        endDate: undefined,
    }) => {
        const reportCriteria = {
            startDate: (0, date_fns_tz_1.formatInTimeZone)(values.startDate || startDate, config_1.PST_TIMEZONE, 'yyyy-MM-dd'),
            endDate: (0, date_fns_tz_1.formatInTimeZone)(values.endDate || endDate, config_1.PST_TIMEZONE, 'yyyy-MM-dd'),
        };
        const nextDayPendingData = {
            postMerchantManagementV1ReportsFilteredSales: {
                ...reportCriteria,
                locationIds: [locationId],
                filter: 'next_day_pending',
            },
        };
        const scheduledPendingData = {
            postMerchantManagementV1ReportsFilteredSales: {
                ...reportCriteria,
                locationIds: [locationId],
                filter: 'scheduled_pending',
            },
        };
        postSalesReportsNextDay(nextDayPendingData);
        postSalesReportsScheduledPending(scheduledPendingData);
    };
    const footerTotalNextDayPend = (0, react_1.useMemo)(() => {
        return (nextDayReport &&
            nextDayReport.length > 0 &&
            (0, utils_1.formatCurrency)((0, utils_1.calcTransaction)(nextDayReport[0].transactions), 2));
    }, [nextDayReport]);
    const footerTotalSchedPend = (0, react_1.useMemo)(() => {
        return (scheduledPendingReport &&
            scheduledPendingReport.length > 0 &&
            (0, utils_1.formatCurrency)((0, utils_1.calcTransaction)(scheduledPendingReport[0].transactions), 2));
    }, [scheduledPendingReport]);
    (0, react_1.useEffect)(() => {
        fetchSalesReport();
    }, [locationId]);
    // Effects
    (0, react_1.useEffect)(() => {
        const transactions = nextDayReport?.[0]?.transactions ?? [];
        setDisplayedNextDayTransactions(transactions);
    }, [nextDayReport]);
    (0, react_1.useEffect)(() => {
        const transactions = scheduledPendingReport?.[0]?.transactions ?? [];
        setDisplayedPendingTransactions(transactions);
    }, [scheduledPendingReport]);
    return {
        displayedNextDayTransactions,
        displayedPendingTransactions,
        handleNextDayFilter,
        handlePendingTransactionFilter,
        footerTotalNextDayPend,
        footerTotalSchedPend,
        salesReportError,
        salesReportLoading,
    };
};
exports.default = useSalesTable;
